import(/* webpackMode: "eager" */ "/vercel/path0/src/app/library/books/garlic-recipes/layout.tsx");
